const jQ = jQuery.noConflict();
function singleProductSidebar() {
    if(jQ('body.single-product #content').length){
        let point = jQ('.single-product .product-custom-grid').offset().top;
        const sidebar = jQ('aside.archive-sidebar');
        if(jQ('.archive-sidebar-content-mobile').is(':visible')){
            const sideHeight = jQ('.archive-sidebar-content-mobile').outerHeight();
            const MainNavHeight = jQ('.main-header').outerHeight() + 20;
            point = point - sideHeight - MainNavHeight;
        }
        if (jQ(window).scrollTop() >= point && sidebar.hasClass('inactive')) {
            sidebar.removeClass('inactive');
        } else if ( jQ(window).scrollTop() < point && !sidebar.hasClass('inactive')) {
            sidebar.addClass('inactive');
        }
    }
}

export default singleProductSidebar;
